import React from 'react';
import {Edit, SimpleForm} from 'react-admin';

import {CustomToolbar, Grid} from '../../components'
import ParkingVehicleFields from './ParkingVehicleFields'

export const ParkingVehicleEdit = props => {
    return (<Edit {...props}>
            <SimpleForm toolbar={<CustomToolbar/>} redirect="list">
                <Grid container spacing={8}>
                    <ParkingVehicleFields readOnly={true}/>
                </Grid>
            </SimpleForm>
        </Edit>
    )
}

export default ParkingVehicleEdit